/**
 * Product Bulk Inquiry JavaScript
 * Handles form validation and tracking
 */

class ProductBulkInquiry {
  constructor() {
    this.form = document.querySelector('.product-bulk-inquiry__form');
    if (!this.form) return;
    
    this.init();
  }

  init() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    
    // Add real-time validation
    const requiredFields = this.form.querySelectorAll('[required]');
    requiredFields.forEach(field => {
      field.addEventListener('blur', () => this.validateField(field));
    });
  }

  validateField(field) {
    if (field.validity.valid) {
      field.classList.remove('error');
      return true;
    } else {
      field.classList.add('error');
      return false;
    }
  }

  handleSubmit(event) {
    // Validate all required fields
    const requiredFields = this.form.querySelectorAll('[required]');
    let isValid = true;

    requiredFields.forEach(field => {
      if (!this.validateField(field)) {
        isValid = false;
      }
    });

    if (!isValid) {
      event.preventDefault();
      return;
    }

    // Track form submission (for analytics)
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'form_submit', {
        event_category: 'Bulk Inquiry',
        event_label: 'Product Inquiry Form',
        value: document.querySelector('[name="contact[quantity_range]"]')?.value || 'unknown'
      });
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductBulkInquiry();
  });
} else {
  new ProductBulkInquiry();
}
